'use client';
import HeroSection from './HeroSection';
import NightToDaySection from './NightToDaySection';
import SolutionSection from './SolutionSection';
import ProcessSection from './ProcessSection';
import CTASection from './CTASection';
import Footer from './Footer';

export default function HomePage() {
  return (
    <>
      <main>
        <HeroSection />
        <NightToDaySection />
        <SolutionSection />
        <ProcessSection />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}
